import { layoutTokens, surfaceTokens } from "@/shared/theme";
import { Box, ButtonBase } from "@mui/material";
import type { ReactNode } from "react";

type ReviewSurfaceProps = {
  onClick: (() => void) | null;
  children: ReactNode;
  inverse?: boolean;
};

export const ReviewSurface = ({ onClick, children, inverse = false }: ReviewSurfaceProps) =>
  onClick ? (
    <ButtonBase
      onClick={onClick}
      sx={{
        display: "block",
        width: "100%",
        textAlign: "left",
        "&:hover": { bgcolor: inverse ? surfaceTokens.inverseHover : surfaceTokens.hover },
        "&:focus-visible": {
          outline: `${layoutTokens.structuralBorder}px solid`,
          outlineColor: inverse ? "background.default" : "primary.main",
          outlineOffset: -2,
        },
      }}
    >
      {children}
    </ButtonBase>
  ) : (
    <Box>{children}</Box>
  );
